import React, { PureComponent } from 'react';
import { wire } from 'react-hot-wire';

import ImpersonateUserInfoBar from 'components/auth/ImpersonateUserInfoBar';
import UserPanel from 'components/battles/user-panel/UserPanel';

class BattlesLayout extends PureComponent {
	render() {
		const WrapperMenu = this.props['components.WrapperMenu'];
		const WrapperMissionList = this.props['components.WrapperMissionList'];
		const hideMissionList = this.props.hideMissionList;

		return (
			<div
				className="main-container el--grow wrapper--col"
				ref={container => {
					this.container = container;
				}}
			>
				<WrapperMenu parent={this} />
				<div className="wrapper--row el--grow mainContentWrapper mainContentContainer">
					{!hideMissionList && (
						<div className="missionListTechnical wrapper--col">
							<div className="wrapper--col el--grow">
								<WrapperMissionList />
							</div>
						</div>
					)}
					<div className="wrapper--col el--grow">{this.props.children}</div>
				</div>
				<UserPanel />
			</div>
		);
	}
}

const Layout = wire(['components.WrapperMenu', 'components.WrapperMissionList'], BattlesLayout);

export function buildBattlesLayout(Component, layoutProps) {
	return props => (
		<ImpersonateUserInfoBar>
			<Layout {...layoutProps}>
				<Component {...props} />
			</Layout>
		</ImpersonateUserInfoBar>
	);
}

export default Layout;
